// extracted by mini-css-extract-plugin
export default {"confirm_modal":"confirm-modal_confirm_modal__udLiY","body":"confirm-modal_body__NtN+j"};